"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BetaTag = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BetaTag_css_1 = require("./BetaTag.css");
var BetaTag = function () { return (react_1.default.createElement(kaleidoscope_1.Label, { className: BetaTag_css_1.betaTag, size: "s" }, "Beta")); };
exports.BetaTag = BetaTag;
